import React from 'react'

import TextField from '@galo-monitor/web-components/TextField'

const InputEmail = (props) => <TextField { ...props } type="email" />

export default InputEmail
